import React, { useState } from "react";
import { forwardRef } from "react";
import { Input } from "react-ui";

import { InputContainer } from "./TreePicklistInput.styles";

interface TreePicklistInputProps {
    value: string;
    hint?: string;
    width?: string | number;
    error?: boolean;
    warning?: boolean;

    onValueChange: (value: string) => void;
}

export const TreePicklistInput = forwardRef<Input, TreePicklistInputProps>(
    ({ value, hint = "", width, ...restProps }, parentRef) => {
        const [isEditing, setIsEditing] = useState(false);
        const valueToShow = isEditing ? value : composeInputValueWithHint(value, hint);

        return (
            <InputContainer style={{ width: width }}>
                <Input
                    {...restProps}
                    ref={parentRef}
                    width={width}
                    value={valueToShow}
                    onFocus={() => {
                        setIsEditing(true);
                    }}
                    onBlur={() => {
                        setIsEditing(false);
                    }}
                />
            </InputContainer>
        );
    }
);

TreePicklistInput.displayName = "TreePicklistInput";

const composeInputValueWithHint = (value: string, hint: string) => {
    if (value === hint) {
        return value;
    }

    return value + (hint && ` - ${hint}`);
};
